import fullInventory from "./full-inventory.svg";

export default function FullInventory({width, height})
{
  return (
    <img src={fullInventory} width={width} height={height}/>
  );
}